import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";

export const PdfViewPage = () => {
  const { attachmentKey } = useParams();

  const [iframeLoading, setIframeLoading] = useState(false);
  const [reportPdfUrl, setReportPdfUrl] = useState("");
  const [progress, setProgress] = useState(0);

  const [getFileUrl, { isLoading, isError, isFetching }] = useLazyGetFileUrlQuery(attachmentKey);

  useEffect(() => {
    if (!attachmentKey) {
      return;
    }

    async function getReportUrl() {
      setIframeLoading(true);
      setProgress(0);
      try {
        let response = await getFileUrl(attachmentKey).unwrap();
        setReportPdfUrl(response);
        // Simulate progress when URL is fetched but before iframe loads
        setProgress(70);
      } catch (err) {
        console.error("Error loading report", err);
        setIframeLoading(false);
        setProgress(0);
      }
    }

    getReportUrl();
  }, [attachmentKey]);

  // Effect to simulate progress when loading
  useEffect(() => {
    let progressInterval;

    if ((isLoading || isFetching || iframeLoading) && progress < 90) {
      progressInterval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 300);
    }

    return () => {
      if (progressInterval) {
        clearInterval(progressInterval);
      }
    };
  }, [isLoading, isFetching, iframeLoading, progress]);

  const handleIframeLoad = () => {
    setIframeLoading(false);
    setProgress(100);
    // Reset progress after a short delay
    setTimeout(() => setProgress(0), 500);
  };

  const handleViewPdf = async (name) => {
    try {
      const url = await getFileUrl(name).unwrap();
      if (url) window.open(url, '_blank');
    } catch (err) {
      console.error("Error assigning therapist", err);
    }
  };

  return (
    <section className="report-outer py-3 position-relative">
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
              <div className="left">
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                  <li className="">
                    <Link
                      className="themeBlue fw-sbold"
                      style={{ textDecoration: "underline" }}
                      to={-1}
                    >
                      <i className="fa fa-arrow-left me-1" aria-hidden="true"></i>
                      Back
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col lg="12">
            {isLoading ? (
              <LoadingIndicator />
            ) : isError ? (
              <ErrorComponent />
            ) : reportPdfUrl && (
              <>
                {(isFetching || iframeLoading || progress > 0) && (
                  <div className="progress mb-2" style={{ height: "4px" }}>
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${progress}%`,
                        height: "4px",
                        background: "#93278F",
                        borderRadius: "8px",
                        transition: "width 0.3s ease"
                      }}
                      aria-valuenow={progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    />
                  </div>
                )}
                {/* <Row>
                  <Col lg="6">
                    <ReportAttachments
                      attachments={attachments}
                      handleViewPdf={handleViewPdf}
                      title={"Attachments:"}
                    />
                  </Col>
                  <Col lg="6">
                    <ReportAttachments
                      attachments={resources}
                      handleViewPdf={handleViewPdf}
                      title={"Resources:"}
                    />
                  </Col>
                </Row> */}
                <iframe
                  onLoad={handleIframeLoad}
                  src={`${reportPdfUrl}#toolbar=0&navpanes=0`}
                  style={{
                    width: "100%",
                    height: "90vh"
                  }}
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}